import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileIcon',
})
export class FileIconPipe implements PipeTransform {
  private static readonly fileTypeMap = {
    picture_as_pdf: ['application/pdf'],
    image: ['image/png', 'image/tiff', 'image/jpeg', 'image/gif'],
    description: [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
  };

  private static readonly defaultIcon = 'attach_file';

  transform(mimeType: string): string {
    if (!mimeType) {
      return FileIconPipe.defaultIcon;
    }

    return Object.entries(FileIconPipe.fileTypeMap).reduce((icon, [iconName, fileTypes]) => {
      const foundType = fileTypes.some(type => type === mimeType);

      return foundType ? iconName : icon;
    }, FileIconPipe.defaultIcon);
  }
}
